import _jsx from "@babel/runtime/helpers/jsx";
var _Label, _Glyphicon;
import React, { useCallback } from 'react';
import { useFeatures } from '@atc/features';
import { Glyphicon, Label } from 'reaxl';
import BatteryHealthBadge from './badges/BatteryHealthBadge';
import CertifiedBadge from './badges/CertifiedBadge';
import FuelTypeBadge from './badges/FuelTypeBadge';
import ProductBadge from './badges/ProductBadge';
import IncentiveBadge from './badges/IncentiveBadge';
import VHRBadge from './badges/VHRBadge';

/**
 *  Displays applicable info badges on listing cards:
 *  - Battery Health
 *  - Highlight alternative fuel type
 *  - Similar listing
 *  - Supplemental search result
 *  - Certified program
 *  - Vehicle History Report quick link
 *
 */
function InventoryListingBadges(_ref) {
  let {
    enableCertifiedBadges = true,
    enableCpoVhrBadges,
    enableVhrBadges = false,
    listing,
    onCertifiedTileClick,
    onProductTileClick
  } = _ref;
  const {
    battery_health: [enableBatteryHealth]
  } = useFeatures(['battery_health']);
  const {
    certifiedTiles = [],
    electricComponentInfo: {
      batteryDegradationInfo
    } = {},
    fuelType,
    hasIncentive = false,
    id = '',
    isSimilarListing,
    isSupplemental,
    listingType = '',
    listingTypes = [],
    productTiles = [],
    searchRadius,
    specifications,
    vhrPreview = []
  } = listing || {};
  const handleCertifiedTileClick = useCallback(event => onCertifiedTileClick(event, listing), [listing, onCertifiedTileClick]);
  const handleProductTileClick = useCallback(event => onProductTileClick(event, listing), [listing, onProductTileClick]);
  return /*#__PURE__*/_jsx("div", {
    className: "display-flex flex-wrap gap-2 margin-vertical-2"
  }, void 0, isSimilarListing && (_Label || (_Label = /*#__PURE__*/_jsx(Label, {
    bsStyle: "info-inverse",
    "data-cmp": "similarMatchBadge"
  }, "similar-match", "Similar Match"))), isSupplemental && /*#__PURE__*/_jsx(Label, {
    bsStyle: "info-inverse",
    className: "display-inline-flex gap-1",
    "data-cmp": "beyondRadiusBadge"
  }, "supplemental", _Glyphicon || (_Glyphicon = /*#__PURE__*/_jsx(Glyphicon, {
    glyph: "map-marker"
  })), `Beyond ${searchRadius} Mi. Radius`), enableCertifiedBadges && certifiedTiles.map(_ref2 => {
    let {
      label
    } = _ref2;
    return /*#__PURE__*/_jsx(CertifiedBadge, {
      label: label,
      listingType: listingType,
      listingTypes: listingTypes,
      onClick: handleCertifiedTileClick
    }, label);
  }), hasIncentive && /*#__PURE__*/_jsx(IncentiveBadge, {}, `incentive-${id}`), /*#__PURE__*/_jsx(FuelTypeBadge, {
    engineName: specifications?.engine?.value,
    fuelGroup: fuelType?.group,
    fuelName: fuelType
  }, "fuel-type"), enableBatteryHealth && /*#__PURE__*/React.createElement(BatteryHealthBadge, Object.assign({
    key: "battery-health"
  }, batteryDegradationInfo)), enableCpoVhrBadges && productTiles.map(badge => /*#__PURE__*/React.createElement(ProductBadge, Object.assign({}, badge, {
    key: badge.label,
    onClick: handleProductTileClick
  }))), enableVhrBadges && vhrPreview.map(type => /*#__PURE__*/_jsx(VHRBadge, {
    type: type
  }, type)));
}
export default InventoryListingBadges;